export { Animated as default } from 'react-native-web';
